import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { WhyWeFeedRaw } from 'features/WhyWeFeedRaw'
import Script from 'next/script'
export default function User() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Why We Feed Raw',
    url: 'https://wefeedraw.com/why-we-feed-raw',
    description: 'The right food for them. The right choice for smart pet parents.',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@type': 'WebPage',
            name: 'Benefits of raw diet for dogs',
            url: 'https://wefeedraw.com/why-we-feed-raw#why-we-feed-raw-1',
            description: 'Improved Digestion',
            about: {
              '@type': 'CreativeWork',
              name: 'Benefits of raw diet for dogs',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@type': 'WebPage',
            name: 'The healthiest food for your dog is raw.',
            url: 'https://wefeedraw.com/why-we-feed-raw#why-we-feed-raw-2',
            description: 'The healthiest food for your dog is raw.',
            about: {
              '@type': 'CreativeWork',
              name: 'The healthiest food for your dog is raw.',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@type': 'WebPage',
            name: 'Why is raw better than cooked?',
            url: 'https://wefeedraw.com/why-we-feed-raw#why-we-feed-raw-3',
            description:
              'Put simply: with cooked foods, your dog has to work harder to get the nutrients he needs.',
            about: {
              '@type': 'CreativeWork',
              name: 'Why is raw better than cooked?',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        },
        {
          '@type': 'ListItem',
          position: 4,
          item: {
            '@type': 'WebPage',
            name: 'Is raw food safe?',
            url: 'https://wefeedraw.com/why-we-feed-raw#why-we-feed-raw-4',
            description:
              'Quality and safety are our top priorities, which is why all of our food goes through HPP (high-pressure processing).',
            about: {
              '@type': 'CreativeWork',
              name: 'Is raw food safe?',
              author: {
                '@type': 'Organization',
                name: 'We Feed Raw'
              },
              publisher: {
                '@type': 'Organization',
                name: 'We Feed Raw',
                logo: {
                  '@type': 'ImageObject',
                  url: 'https://wefeedraw.com/assets/isotype-background-brown.svg'
                }
              }
            }
          }
        }
      ]
    }
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('why-we-feed-raw:page-title')}</title>
        <meta name="title" content={t('why-we-feed-raw:meta-title')} />
        <meta name="description" content={t('why-we-feed-raw:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/why-we-feed-raw" />
      </Head>

      <main>
        <Script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
        <WhyWeFeedRaw />
      </main>
    </div>
  )
}
